// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_MySubscriptionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_MySubscriptionsResponse — list of all subscriptions (live +
 * terminal history) for every franchise the caller can access.
 *
 * Used by GET /subscriptions/mine. Row shape includes grace_ends_at /
 * grace_days_remaining (see Subscriptions_SubscriptionRow).
 */
import type { Subscriptions_SubscriptionRow } from './Subscriptions_SubscriptionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_MySubscriptionsResponseDados {
rows: Subscriptions_SubscriptionRow[]
}

export type Subscriptions_MySubscriptionsResponse = ApiResponse<Subscriptions_MySubscriptionsResponseDados>;

registerResponseContract('Subscriptions_MySubscriptionsResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      subscription_id:        { type: 'number',  required: false },
      franchise_id:           { type: 'number',  required: true },
      franchise_name:         { type: 'string',  required: false },
      plan_name:              { type: 'string',  required: false },
      provider:               { type: 'string',  required: false },
      currency:               { type: 'string',  required: false },
      price_cents:            { type: 'number',  required: false },
      status:                 { type: 'string',  required: false },
      exempt:                 { type: 'number',  required: false },
      grace_until:            { type: 'string',  required: false },
      grace_ends_at:          { type: 'string',  required: false },
      grace_days_remaining:   { type: 'number',  required: false },
      paid_through:           { type: 'string',  required: false },
      current_period_start:   { type: 'string',  required: false },
      current_period_end:     { type: 'string',  required: false },
      created_at:             { type: 'string',  required: false },
      setup_status:           { type: 'string',  required: false },
      has_pending_setup_fee:  { type: 'boolean', required: false },
      credits_balance_micro:  { type: 'number',  required: false },
      setup_fee_amount_cents: { type: 'number',  required: false },
      setup_fee_currency:     { type: 'string',  required: false },
    },
  },
})
